module.exports = __webpack_public_path__ + "static/media/rugrats-post-game-susie.3d650b2d.png";